/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */
import axios from "axios"
import qs from "qs"

export const isProduction = process.env.GATSBY_SITE_ENV === "production"
export const isCaptchaMode = process.env.GATSBY_CAPTCHA_MODE === "live"

const strapiBaseURL = `${process.env.GATSBY_STRAPI_SRC}`
const token = process.env.GATSBY_STRAPI_FORM_TOKEN

const sitebaseURL = process.env.GATSBY_SITE_URL

const authInstance = axios.create({
  baseURL: strapiBaseURL,
  headers: {
    Authorization: `Bearer ${token}`,
    // "Content-Type": "multipart/form-data"
  },
})

export const postFileData = async (data) => {
  const res = await authInstance
    .post("upload", data)
    .then((response) => {
      // Success
      if (response.statusText === "OK") {
        return {
          success: true,
          ...response.data,
        }
      }
      return { success: false }
    })
    .catch((error) => {
      // Failed
      if (error.response) {
        return {
          success: false,
          message: error.response.data,
        }
      }
      // Service error

      return {
        success: false,
        message: "Service error",
      }
    })

  return res
}

export const postFormData = async (data) => {
  const res = await authInstance
    .post("/api/stb-forms/forms", data)
    .then((response) => {
      // Success
      if (response.statusText === "OK") {
        return {
          success: true,
          ...response.data,
        }
      }
      return { success: false }
    })
    .catch((error) => {
      // Failed
      if (error.response) {
        return {
          success: false,
          message: error.response.data,
        }
      }
      // Service error

      console.log("Service error", error)
      return {
        success: false,
        message: "Service error",
      }
    })

  return res
}

export const sendMail = (postData) => {
  return window.fetch(`${sitebaseURL}/api/form`, {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: qs.stringify(postData),
  })
}

export const formTracking = ({ eventTracking, formName }) => {
  // tracking event
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: "formSubmit",
    formType: `form-${eventTracking}`,
    formId: `form-${eventTracking}`,
    formName,
    formLabel: formName,
  })
}

export const SUCCESS_MSG =
  "Thank you for contacting us. A member of our team will contact you shortly."
